import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';

export function Gallery() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.gallery.anchor} className="section">
      <h2 className="section-title">{t('gallery.title')}</h2>
      <div className="tba">{t('gallery.tba')}</div>
    </section>
  );
}
